import { ChangeDetectionStrategy, Component, ElementRef, Inject, inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { Persona } from 'src/app/models/personas.interface';
import { ReviewSession } from 'src/app/models/review.interface';
import { ReviewService } from 'src/app/services/review.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-reviewer-info-dialog',
  templateUrl: './reviewer-info-dialog.html',
  styleUrls: ['./reviewer-info-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewerInfoDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ReviewerInfoDialogComponent>);
  @ViewChild('fileInputPersona') fileInputPersona!: ElementRef;
  private uploadInProgressSubject = new BehaviorSubject<boolean>(false);
  private uploadSuccessSubject = new BehaviorSubject<boolean>(false);

  uploadInProgress$ = this.uploadInProgressSubject.asObservable();
  uploadSuccess$ = this.uploadSuccessSubject.asObservable();
  constructor(
    @Inject(MAT_DIALOG_DATA) public persona: Persona,
    private reviewerService: ReviewService,
    private snackBar: MatSnackBar
  ) {}

  reviewFile() {
    this.dialogRef.close();
  }

  inputFile() {
    this.fileInputPersona.nativeElement.click();
  }

  onDocumentUpload(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    if (files) {
      const file = files[0];
      this.uploadInProgressSubject.next(true);

      this.reviewerService.createReviewSession(file.name, [this.persona.id ?? '']).subscribe({
        next: (data: ReviewSession) => {
          console.log('Review completed successfully (in dialog): ', data);
          // this.recentlyReviewed.splice(0, 0, data);
          this.uploadDocs(data.review_id, files);
        },

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        error: (error: any) => {
          // this.recentlyReviewed.splice(0, 1); // remove failed document from list
          console.error('There was an error while processing the documents: ', error);
          this.uploadInProgressSubject.next(false);
          this.snackBar.open('Failed to complete document review', 'Error', { duration: 5000 });
        }
      });
    }
  }

  uploadDocs(reviewId: string, files: FileList) {
    this.reviewerService.uploadFilesToReview(reviewId, files).subscribe({
      next: () => {
        this.uploadInProgressSubject.next(false);
        this.uploadSuccessSubject.next(true);
        console.log('Upload successful');
        // this.snackBar.open('Upload successful', 'Close', { duration: 5000 });
      },
      error: error => {
        // this.recentlyReviewed.splice(0, 1); // remove failed document from list
        this.snackBar.open('Error uploading files', 'Close');
        console.error('Upload failed', error);
        this.uploadInProgressSubject.next(false);
      }
    });
  }
}
